<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left text-capitalize">Fleet {{ type }} Service Type</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="createRecord">Add</v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th v-if="user.type === 'admin'">Company</th>
                        <th>Name</th>
                        <th>Recurring</th>
                        <th>Frequency Days</th>
                        <th>Frequency Miles</th>
                        <th>Reminder Needed</th>
                        <th>Applies to All Vehicle Types</th>
                        <th v-if="type === 'inspection'">Driver DVIR Completes It</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="record in records" v-if="records.length" class="text-left">
                        <td v-if="user.type === 'admin'">{{ record.company?.company_name ?? '' }}</td>
                        <td>{{ record.name }}</td>
                        <td>
                            <v-icon :icon="`mdi-${record.recurring?'check-circle':'close-circle'}`"/>
                        </td>
                        <td>{{ record.frequency_days }}</td>
                        <td>{{ record.frequency_miles }}</td>
                        <td>
                            <v-icon :icon="`mdi-${record.reminder_needed?'check-circle':'close-circle'}`"/>
                        </td>
                        <td>
                            <v-icon :icon="`mdi-${record.applies_to_all?'check-circle':'close-circle'}`"/>
                        </td>
                        <td v-if="type === 'inspection'">
                            <v-icon :icon="`mdi-${record.completed_by_driver_inspection?'check-circle':'close-circle'}`"/>
                        </td>
                        <td>
                            <v-btn-group v-if="user.type === 'admin' || user.company?.id === record.company_id"
                                         density="compact" divided variant="outlined">
                                <v-btn class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editRecord(record)">Edit
                                </v-btn>
                                <v-btn class="text-error" prepend-icon="mdi-delete" size="x-small"
                                       @click="deleteRecord(record)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" class="text-center" colspan="11">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else class="text-center" colspan="11">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @update:model-value="fetchRecords"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <Creat_Edit v-if="dialogSwitch"
                v-model="dialogSwitch"
                :service-type="serviceType"
                :type="type"
                :record="selectedRecord"
                @addRecord="addRecord"
                @updateRecord="updateRecord"/>
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Creat_Edit from "@/components/dialogs/fleet/ServiceType_Create_Edit.vue";

const router = useRouter();
const {user} = useAuthStore();
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const records = ref([]);
const dialogSwitch = ref(false);
const selectedRecord = ref(null);
const {showSnackbar} = useSnackbarStore();
const type = ref(router.currentRoute.value.params.type);
const serviceType = computed(() => {
    return type.value === 'maintenance' ? 0 : 1;
})

onMounted(() => {
    fetchRecords();
});

const fetchRecords = () => {
    send('get', `fleet/service-types`, {type: serviceType.value})
        .then((response) => {
            records.value = response.data.data.data ?? [];
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Models could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const addRecord = (record) => {
    records.value.unshift(record);
}
const createRecord = () => {
    selectedRecord.value = null;
    dialogSwitch.value = true;
}
const editRecord = (record) => {
    selectedRecord.value = record;
    dialogSwitch.value = true;
}
const updateRecord = (record) => {
    records.value.map((comp, index) => {
        if (comp.id === record.id) {
            records.value[index] = record;
        }
    });
    selectedRecord.value = null;
}
const deleteRecord = (record) => {
    if (confirm(`Are you sure to delete "${record.name}" record?`)) {
        send('delete', `fleet/service-types/${record.id}`)
            .then((response) => {
                if (response.data.success) {
                    records.value.map((item, index) => {
                        if (item.id === record.id) {
                            records.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${record.name}" manufacturer could not be deleted`, 'error')
                }
            })
    }
}

watch(() => router.currentRoute.value.params.type, (newType) => {
    type.value = newType;
    currentPage.value = 1;
    fetchRecords();
    selectedRecord.value = null;
})
</script>
